import React, { Component } from 'react';
import _ from 'lodash';
import { Image, Search, MainSlider } from '../components';
import { withRedux } from '../hoc';
import { getServiceUrl } from '../utils';
import { getPageserviceAction } from '../actions/page/service';

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    page: _.get(state, 'page')
  };
};

const actions = {
  getPageserviceAction
};

@withRedux(mapStateToProps, actions)
export default class Service extends Component {
  componentDidMount() {
    this.props.actions.getPageserviceAction();
  }
  render() {
    const { t } = this.props;
    const services = _.get(this.props, 'page.service.data.services');
    return (
      <div className="service-page container-wrapper">
        <div className="search-block">
          <Search.Main />
        </div>
        <div className="banner-block">
          <div className="topic">- {t('Service')} -</div>
          <div className="media-slide">
            <MainSlider data={_.get(this.props, 'page.service.data.image_slide')} />
          </div>
        </div>
        <div className="service-items">
          <div className="container">
            <div className="items">
              {_.map(services, (service, key) => {
                const full_file_path = `${getServiceUrl()}/${_.get(service, 'media_icon_data.path')}`;
                return (
                  <div className="item" key={key}>
                    <div className="color-block" />
                    <div className="icon">
                      <Image src={full_file_path} alt={t(_.get(service, 'title'))} />
                    </div>
                    <div className="title">{t(_.get(service, 'title'))}</div>
                    <div className="detail">{t(_.get(service, 'detail'))}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Service.js